import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

const SELECT_CSS =
  "w-1/2 bg-gray-50 block border border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:border-blue-500 dark:focus:ring-blue-500 dark:placeholder-gray-400 dark:text-white focus:border-blue-500 focus:ring-blue-500 rounded-lg text-gray-900 text-sm";

const ExpensesMonthSwitcher = ({
  expensesListKind,
  monthValue,
  setMonthValue,
}) => {
  const [initialYear, initialMonth] = monthValue.split("-");
  const [year, setYear] = useState(initialYear);
  const [month, setMonth] = useState(Number(initialMonth));

  useEffect(() => {
    setMonthValue(`${year}-${month}`);
  }, [year, month]);

  if (expensesListKind !== "monthly") {
    return null;
  }

  return (
    <div className="flex space-x-2 mt-4">
      <select
        id="month"
        value={month}
        onChange={(e) => setMonth(Number(e.target.value))}
        className={SELECT_CSS}
      >
        {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
          <option key={month} value={month}>
            {new Date(0, month - 1).toLocaleString("default", {
              month: "long",
            })}
          </option>
        ))}
      </select>
      <select
        id="year"
        value={year}
        onChange={(e) => setYear(e.target.value)}
        className={SELECT_CSS}
      >
        {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(
          (year) => (
            <option key={year} value={year}>
              {year}
            </option>
          )
        )}
      </select>
    </div>
  );
};

ExpensesMonthSwitcher.propTypes = {
  expensesListKind: PropTypes.string.isRequired,
  monthValue: PropTypes.string.isRequired,
  setMonthValue: PropTypes.func.isRequired,
};

export default ExpensesMonthSwitcher;
